import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import get from 'lodash.get';
import { FormattedMessage } from 'react-intl';
import PhoneIcon from 'dibs-vg/dist/react/phone';

import { PdpSharedCallDealerModalLoader } from './PdpSharedCallDealerModal/PdpSharedCallDealerModalLoader';
import { PdpSharedFollowDealer } from '../../mutations/PdpSharedFollowDealer';
import { sharedLoginCheck } from '../../authentication/sharedLoginCheck';
import { isEmailOnly } from 'dibs-cookie-jar/exports/isEmailOnly';
import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';

import styles from './PdpSharedCallDealerCta.scss';

export class PdpSharedCallDealerCtaComponent extends React.Component {
    constructor() {
        super();
        this.state = {
            isModalOpen: false,
            userId: null,
        };

        this.onAuthSuccess = this.onAuthSuccess.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onCallDealerModalFollow = this.onCallDealerModalFollow.bind(this);
        this.onCallDealerClick = this.onCallDealerClick.bind(this);
    }

    onAuthSuccess({ userId }) {
        this.setState({
            isModalOpen: true,
            userId,
        });
    }

    closeModal() {
        this.setState({ isModalOpen: false });
    }

    onCallDealerModalFollow() {
        const { userId } = this.state;
        const {
            item: { seller },
            relay,
        } = this.props;
        const favoriteId = get(seller, 'favoritesByUser[0].serviceId', null);
        if (favoriteId) {
            // just close modal if seller already favorited
            this.closeModal();
        } else {
            PdpSharedFollowDealer.commit(relay.environment, {
                userId,
                sellerId: seller.id,
                sellerPk: seller.serviceId,
                favoriteId,
                onCompleted: (payload, errors) => {
                    if (!errors) {
                        this.closeModal();
                    }
                },
            });
        }
    }

    onCallDealerClick() {
        const { user } = this.props;
        const isFullAccount = !get(user, 'authMetadata.emailOnly');
        const hasEmailToken = isEmailOnly(document.cookie);
        if (hasEmailToken) {
            const { relay } = this.props;
            const email = get(user, 'profile.email');
            authModalLoader
                .show({
                    action: isFullAccount
                        ? authModalLoader.constants.LOGIN
                        : authModalLoader.constants.FORGOT_PASSWORD,
                    flow: isFullAccount
                        ? authModalLoader.constants.LOGIN_EMAIL_TOKEN_CALL_SELLER_FLOW
                        : authModalLoader.constants.CREATE_PASSWORD_CALL_SELLER_FLOW,
                    email,
                    relayEnvironment: relay.environment,
                })
                .then(({ userId }) => {
                    if (userId) {
                        this.onAuthSuccess({ userId });
                    }
                });
        } else {
            sharedLoginCheck({ onSuccess: this.onAuthSuccess });
        }
    }

    render() {
        const { isModalOpen, userId } = this.state;
        const {
            item,
            item: { seller },
        } = this.props;
        const itemId = get(item, 'serviceId');
        const telephone = get(seller, 'trackedPhone.phoneNumber');
        return telephone ? (
            <Fragment>
                <span className={`${styles.link} standard-link`} onClick={this.onCallDealerClick}>
                    <PhoneIcon className={styles.phoneIcon} />
                    <FormattedMessage
                        id="PdpSharedCallDealerCta.cta_link"
                        defaultMessage="Call seller through 1stdibs"
                    />
                </span>
                {userId && (
                    <PdpSharedCallDealerModalLoader
                        userId={userId}
                        itemId={itemId}
                        isOpen={isModalOpen}
                        handleCloseClick={this.closeModal}
                        onFollowDealer={this.onCallDealerModalFollow}
                        location="pdp"
                    />
                )}
            </Fragment>
        ) : null;
    }
}

PdpSharedCallDealerCtaComponent.propTypes = {
    relay: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    user: PropTypes.object,
};

export const PdpSharedCallDealerCta = createFragmentContainer(PdpSharedCallDealerCtaComponent, {
    item: graphql`
        fragment PdpSharedCallDealerCta_item on Item {
            serviceId
            seller {
                id
                serviceId
                favoritesByUser(userIds: $userId) @include(if: $fetchUser) {
                    serviceId
                }
                trackedPhone {
                    phoneNumber
                }
            }
        }
    `,
    user: graphql`
        fragment PdpSharedCallDealerCta_user on User {
            profile {
                email
            }
            authMetadata {
                emailOnly
            }
        }
    `,
});
